import { ValidationProps } from 'ui/common/validation/types';
import { validateComplexValue } from 'app/area/codetable/item/screen-renderer/screen-validate/helpers';
import { ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { CodeFieldWireKey } from 'app/area/codetable/types-store';
import { ValidationData } from 'app/area/codetable/item/validation/validate';

export const validateConsequenceLikelihood = (validationData: ValidationData): { [key: string]: ValidationProps } => {
  const { codeItem, translation } = validationData;
  
  const likelihoodValidation = validateComplexValue(ScreenPicker.likelihood, codeItem, translation);
  const categoryValidation = validateComplexValue(CodeFieldWireKey.category, codeItem, translation);

  return {
    ...likelihoodValidation,
    ...categoryValidation
  };
};
